"use strict";

import $ from "jquery";
import dot from "dot";
import ListingBase from "../../../_scripts/listingBase.js";
import FiltersGroup from "../../molecules/filters-group/filters-group";
import LoadingIcon from "../../atoms/loading-icon/loading-icon";
import Cookies from "js-cookie";

export default class Newsroom extends ListingBase {
  constructor() {
    let $newsroom = $(".newsroom");
    let $content = $(".newsroom__content", $newsroom);
    let $filtersGroup = $(".filters-group", $newsroom);
    let $pagination = $(".pagination", $newsroom);
    let $list = $(".newsroom__list", $newsroom);
    const typeIsDropdown = $newsroom.hasClass('newsroom--dropdown-filter') ? true : false ;

    let dataModel = {
      page: 1,
      support: "",
      type: "",
      year: "",
    };

    let parametersModel = {
      page: 1,
      support: "",
      type: "",
      year: "",
    };

    super($pagination, dataModel, parametersModel);

    this.filters = new FiltersGroup($filtersGroup);
    // Setup basic
    this.$template = $("#newsroomTemplate").html();
    this.$content = $content;
    this.$list = $list;
    this.endpoint = $newsroom.data("endpoint");
    this.$loadingIcon = new LoadingIcon($(".loading-icon", $newsroom));

    // Define fields
    let $support = $("#support", $filtersGroup);
    let $year = $("#year", $filtersGroup);
    let $type;
    if(typeIsDropdown) {
      $type = $("#type", $filtersGroup);
    }
    else {
      $type = $('input[name="type"]', $filtersGroup);
    }

    // get all parameters value
    let queries = this.getUrlQueries();

    let type;
    if(typeIsDropdown) {
      if (queries["type"]) {
        $type.val(queries["type"]);
        $type.trigger("change.customSelect");
      }
    }
    else {
      type = this.setupCheckboxes("type", queries, this.filters);
    }

    let page = 1;
    if (queries["page"]) {
      page = encodeURIComponent(queries["page"]);
    }

    if (queries["year"]) {
      $year.val(queries["year"]);
      $year.trigger("change.customSelect");
    }

    if ($support) {
      if (queries["support"]) {
        $support.val(queries["support"]);
        $support.trigger("change.customSelect");
      } else {
        //Check if there's cookie value for IMDA profile, if profile is present, pre-select the profile filter
        // if (Cookies.get("imda_profile")) {
        //   let profile = Cookies.get("imda_profile");
        //   if (profile === "profile0") {
        //     profile = "profile1";
        //   }
        //   let matchedProfileOption = $(
        //     'option[data-profile="' + profile + '"]'
        //   );

        //   if (matchedProfileOption) {
        //     $support.val(matchedProfileOption.val());
        //     $support.trigger("change.customSelect");
        //   }
        // }
      }
    }

    // Setup Data Structure
    this.data.support = $support ? $support.val() : "";
    if(typeIsDropdown) {
      this.data.type = $type.val();
    }
    else {
      this.data.type = type;
    }
    this.data.year = $year.val();
    this.data.page = page;

    this.parameters.support = this.data.support;
    this.parameters.type = this.data.type;
    this.parameters.year = this.data.year;
    this.parameters.page = this.data.page;

    const filterValues = this.getFilterValues();

    this.dataLayerModel = {
      event: "historyChange-v2",
      profileType: `${this.parameters.support ? this.parameters.support : ""}`,
      pressreleaseType: `${this.parameters.type ? this.parameters.type : ""}`,
      contentDate: `${this.parameters.year ? this.parameters.year : ""}`,
      filters: filterValues ? filterValues : "",
      destinationurl: ""
    };

    this._updateData = () => {
      this.$content.addClass("content-updating");
      this.$loadingIcon.playAnimation();
      this._pushDataLayer();
  
      let scrollPos = $(window).scrollTop();
      if (scrollPos >= this.$content.offset().top) {
        $("html, body").animate({
          scrollTop: this.$content.offset().top - 140,
        });
      }
  
      let callback = (res) => {
        this._renderTemplate(res);
        if (res.items.length == 0) {
          this.$pagination.hide();
        } else {
          this.$pagination.show();
          this._renderPagination(res.totalpages);
        }
      };
  
      this.updateData({
        endpoint: this.endpoint,
        data: this.data,
        callback: callback,
      });
    }

    window.onpopstate = (e) => {
      this.data.support = e.state.support;
      this.data.type = e.state.type;
      this.data.year = e.state.year;
      this.data.page = e.state.page;

      this.parameters.support = this.data.support;
      this.parameters.type = this.data.type;
      this.parameters.year = this.data.year;
      this.parameters.page = this.data.page;

      if ($support) {
        $support.val(this.data.support);
        $support.trigger("change.customSelect");
      }

      queries = this.getUrlQueries();
      if(typeIsDropdown) {
        $type.val(this.data.type);
        $type.trigger("change.customSelect");
      }
      else {
        type = this.setupCheckboxes("type", queries, this.filters);
      }

      $year.val(this.data.year);
      $year.trigger("change.customSelect");

      this._updateData();
    };

    // Add listener
    if ($support) {
      $support.on("change", (e) => {
        this.data.support = $support.val();
        this.parameters.support = this.data.support;
        this.data.page = 1;
        this.parameters.page = 1;
        this._updateData();
        this.updateURL();
      });
    }

    $year.on("change", (e) => {
      let $value = $year.val();
      if ($value.startsWith("/")) {
        window.location = $value;
      } else {
        this.data.year = $year.val();
        this.parameters.year = this.data.year;
        this.data.page = 1;
        this.parameters.page = 1;
        this._updateData();
        this.updateURL();
      }
    });

    if(typeIsDropdown) {
      $type.on("change", (e) => {
        let $value = $type.val();
        if ($value.startsWith("/")) {
          window.location = $value;
        } else {
          this.data.type = $type.val();
          this.parameters.type = this.data.type;
          this.data.page = 1;
          this.parameters.page = 1;
          this._updateData();
          this.updateURL();
        }
      });
    }
    else {
      this.addCheckboxListener(
        "type",
        "type",
        this.filters,
        this._updateData
      );
      
      this.data.type = this.updateCheckboxValues($type, this.filters);
      this.parameters.type = this.data.type;
    }


    // Make call upon page load
    this._updateData();
    this.updateURL(true);
  }

  _renderTemplate(data) {
    let dotTemplate = dot.template(this.$template)(data.items);

    this.$list.html(dotTemplate);

    $('.newsroom__list .teaser-card__link').map((i,ele) => {
      $(ele).on('click', (e) => {
        e.preventDefault();

        const dataUrl = $(ele).closest("a").attr("href");
        const dataTarget = $(ele).closest("a").attr("target");

        this.dataLayerModel.destinationurl = dataUrl;
        dataLayer.push(this.dataLayerModel);

        if (dataTarget == "_blank") {
          window.open(dataUrl, dataTarget);
        } else {
          window.open(dataUrl, "_self");
        }
      });
    });

    setTimeout(() => {
      this.$content.addClass("content-loaded");
      this.$content.removeClass("content-updating");
      this.$loadingIcon.restartFrame();
    }, 250);
  }

  _renderPagination(totalpages) {
    let callback = () => {
      this.$pagination.find("a").map((i, ele) => {
        let $this = $(ele);

        $this.on("click", (e) => {
          e.preventDefault();
          this.data.page = $this.data("page");
          this.parameters.page = this.data.page;

          this._updateData();
          this.updateURL();
        });
      });
    };

    this.pagination.update(this.data.page, totalpages, callback);
  }

  getFilterValues() {
    return `${
      this.parameters.support === "all" || this.parameters.support === "All"
        ? "profileType all|"
        : this.parameters.support
        ? this.parameters.support + "|"
        : ""
    }${
      this.parameters.type === "all" || this.parameters.type === "All"
        ? "pressreleaseType all|"
        : this.parameters.type
        ? this.parameters.type + "|"
        : ""
    }${
      this.parameters.year === "all" || this.parameters.year === "All"
        ? "contentDate all|"
        : this.parameters.year
        ? this.parameters.year
        : ""
    }`;
  }

  _pushDataLayer() {
    this.dataLayerModel.profileType = `${this.parameters.support ? this.parameters.support : ""}`;
    this.dataLayerModel.pressreleaseType = `${this.parameters.type ? this.parameters.type : ""}`;
    this.dataLayerModel.contentDate = `${this.parameters.year ? this.parameters.year : ""}`;
    this.dataLayerModel.filters = this.getFilterValues() ? this.getFilterValues() : "";
    this.dataLayerModel.destinationurl = '';

    window.dataLayer = window.dataLayer || [];
    dataLayer.push(this.dataLayerModel);
  }
}
